// Libraries
import React from 'react';

// App
import SalesPageContent from '@shared/modules/Sales/components/SalesPageContent';
import SidebarPageV2 from 'modules/App/components/SidebarPageV2';

const SalesPage = () => {
  return (
    <SidebarPageV2 selected={'sales'}>
      <SalesPageContent />
    </SidebarPageV2>
  );
};

export default SalesPage;
